import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import './LoadingFactorView.scss';
import classnames from 'classnames';

const LoadingFactorHeader = () => {
  return (
    <FlexContainer className="gap-20">
      <FlexContainer className="image" />
      <FlexContainer className="flex-column width100">
        <FlexContainer className="line-box" />
        <FlexContainer className="margt20 line-box" />
      </FlexContainer>
    </FlexContainer>
  );
};

const TradelineLoader = () => {
  return (
    <FlexContainer
      className={
        'flex-column grayShadow16 margt16 padlr30 padb24 padt30 m-padt18 m-pad10 border-rad8px'
      }
    >
      <FlexContainer className="gap-20">
        <FlexContainer className="flex-column width100">
          <FlexContainer className="line-box" />
          <FlexContainer className="margt20 line-box" />
          <FlexContainer className="margt20 line-box" />
        </FlexContainer>
        <FlexContainer className="flex-column">
          <FlexContainer className="image" />
          <FlexContainer className="margt12 line-box" />
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className="margt16 tradeline-box border-rad8px" />
    </FlexContainer>
  );
};

export const SingleModuleLoader = props => {
  const { singleModuleClassName } = props;
  const classNames = classnames(
    'flex-column dashboardLoading',
    singleModuleClassName,
  );
  return (
    <FlexContainer className={classNames}>
      <TradelineLoader />
    </FlexContainer>
  );
};

export const LoadingFactorView = () => {
  return (
    <FlexContainer
      className={'flex-column margtb24 marglr48 m-marglr16 dashboardLoading'}
    >
      <LoadingFactorHeader />
      <FlexContainer className="margt12 line-box" />
      <FlexContainer className="margt12 line-box" />
      <FlexContainer className="margt12 line-box" />
      <FlexContainer className="margt44 box border-rad8px" />
      <FlexContainer className="margt24 line-box" />
      <FlexContainer className="margt12 line-box" />
      <TradelineLoader />
      <TradelineLoader />
    </FlexContainer>
  );
};
